export default __webpack_public_path__ + "static/user-shield-light.png";